





<auth-layout title="Reset Password" subTitile="You can reset your password here.">


    <form [formGroup]="resetPassword">
        <div class="form-group">
            <label for="username">New Password<span class="redis">*</span></label>
            <div class="input-control">
                <input type="text" class="form-control" placeholder="Enter your new password"
                    [type]="changetype?'password':'text'" maxlength="60" (keypress)="preventSpace($event)"
                    onselectstart="return false;" onpaste="return false;" oncopy="return false;" oncut="return false"
                    ondrag="return false" ondrop="return false" autocomplete="off" formControlName="password">


                <span class="eyeicon" (click)="changetype = !changetype">
                    <!-- <img src="assets/latest/pass.svg" alt=""> -->
                    <img src="assets/latest/eye2.svg" alt="" *ngIf="!changetype">
                    <img src="assets/latest/eye1.svg" alt="" *ngIf="changetype">
                </span>
            </div>
            <div class="for-validation mb-4">
                <div class="for-validation text-danger"
                    *ngIf="resetPassword.get('password')?.hasError('required') && resetPassword.get('password')?.touched">
                    *Password is
                    required.
                </div>

            </div>
        </div>
        <div class="form-group">
            <label for="username">Confirm Password<span class="redis">*</span></label>
            <div class="input-control">
                <input [type]="changetypes?'password':'text'" placeholder="Enter your confirm password"
                    class="form-control" id="password" maxlength="16" (keypress)="preventSpace($event)"
                    onselectstart="return false;" onpaste="return false;" oncopy="return false;" oncut="return false"
                    ondrag="return false" ondrop="return false" autocomplete="off" formControlName="confirmPassword">
                <span class="eyeicon" (click)="changetypes = !changetypes">
                    <!-- <img src="assets/latest/pass.svg" alt=""> -->
                    <img src="assets/latest/eye2.svg" alt="" *ngIf="!changetypes">
                    <img src="assets/latest/eye1.svg" alt="" *ngIf="changetypes">
                </span>
            </div>
            <div class="for-validation  mb-3 ">
                <div class="for-validation  text-danger"
                    *ngIf="resetPassword.get ('confirmPassword')?.hasError('required') && resetPassword.get('confirmPassword')?.dirty">
                    *Repeat Password is required.</div>


                <div class="for-validation  text-danger"
                    *ngIf="resetPassword.get('password')?.value !=resetPassword.get('confirmPassword')?.value && resetPassword.get('confirmPassword')?.dirty && resetPassword.get('confirmPassword')?.value">
                    *Password and confirm password must be match.
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-between" style="align-items: center;">
            <div class="left-wrap">
                <button class="for-login btn text-white btn-block btn-primary"  (click)="navigateToResetPassword()"
                    [disabled]="!resetPassword.valid" type="submit">Reset Password</button>
            </div>


        </div>
    </form>


</auth-layout>